import { authenticationAction } from "_actions";
import Emitter from "_actions/emitter";
import React from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { SiteFeatures } from "config/siteFeatures";

const NavUserBox = (props) => {
  const getCurrency = (value) => {
    switch (value) {
      case "EUR":
        return "€";
      case "USD":
        return "$";
      default:
        return value;
    }
  };
  return (
    <Translation>
      {(t) => (
        <div className="flex items-center gap-1.5 shrink-0">
          <span onClick={SiteFeatures.DEPOSIT_SYSTEM ? () => Emitter.emit("BALANCE_MODAL", true) : undefined} className="btn-xs	text-white btn btn-ghost">
            {`${(props?.wallet?.balance ?? 0).toLocaleString("tr-TR", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })} ${getCurrency(props?.user?.Currency)}`}
          </span>
          {SiteFeatures.DEPOSIT_SYSTEM && (
            <>
              <button
                type="button"
                onClick={() => Emitter.emit("BALANCE_MODAL", "deposit")}
                aria-label={t("BALANCE_MODAL_DEPOSIT_BUTTON")}
                className="shrink-0 w-6 h-6 rounded-md bg-emerald-500 hover:bg-emerald-400 flex items-center justify-center text-white transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
              </button>
              <button
                type="button"
                onClick={() => Emitter.emit("BALANCE_MODAL", "withdraw")}
                aria-label={t("BALANCE_MODAL_WITHDRAW_BUTTON")}
                className="shrink-0 w-6 h-6 rounded-md bg-secondary-50 hover:bg-primary-400 flex items-center justify-center text-white transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12h15" />
                </svg>
              </button>
            </>
          )}
        </div>
      )}
    </Translation>
  );
};
const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn ,wallet } = authentication;

  return {
    user,
    loggedIn,
    wallet
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateUser: (user) => dispatch(authenticationAction.UpdateUser(user)),
    LoginSuccess: (user) => dispatch(authenticationAction.LoginSuccess(user)),
    LoginFailure: () => dispatch(authenticationAction.LoginFailure()),
    logout: () => dispatch(authenticationAction.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavUserBox);
